import { mutatorAction } from 'satcheljs';
import { ExtendedPalette } from '../store/schema/ExtendedTheme';
import store from '../store/store';
import { FluentTheme } from 'owa-fluent-fabric';

export default mutatorAction(
    'MUTATE_FABRIC_THEME',
    (themeSymbols: Partial<ExtendedPalette>, isDarkTheme: boolean) => {
        store().palette = { ...getFluentPalette(isDarkTheme), ...themeSymbols };
        store().isInverted = isDarkTheme;
    }
);

function getFluentPalette(isDarkTheme: boolean) {
    if (isDarkTheme) {
        return null;
    }

    return FluentTheme.palette;
}
